export const selectExclusiveContent = (state) => {
    const exclusiveContent = state.selectedExclusiveContent;
    return exclusiveContent;
};
//# sourceMappingURL=selectors.js.map